import { replaceTokensInUrl } from '@cat-ecom/common/utils/stringUtils';
import { HEADLESS_PARTS_DIAGRAM_REDIRECTION_LINK } from 'constants/links';
import queryString from 'query-string';
import {
  suggestedKeyword,
  suggestedDiagram
} from 'services/searchSuggestions/types';

export const getSuggestedKeywords = (
  suggestedKeyWords: Array<suggestedKeyword>,
  model: string,
  serialNumber: string,
  esite?: string
) => {
  return suggestedKeyWords?.map((item) => ({
    ...item,
    value: `${esite}${queryString.stringify(
      {
        ...queryString.parse(item.value, { decode: false }),
        ...(model && { model, filterByEquipment: 'true' }),
        ...(serialNumber && { serialNumber })
      },
      { encode: false }
    )}`
  }));
};

export const getSuggestedDiagrams = (
  suggestedDiagram: Array<suggestedDiagram>,
  esiteUrl: string
) => {
  const numberOfItems = 5;

  const partsDiagram = suggestedDiagram
    ?.slice(0, numberOfItems)
    .map((item) => ({
      ...item,
      name: `${item.partNumber} ${item.name}`,
      value: `${esiteUrl}${replaceTokensInUrl(
        HEADLESS_PARTS_DIAGRAM_REDIRECTION_LINK,
        item.systemId,
        item.componentId,
        item.systemControlNumber
      )}`
    }));

  return partsDiagram;
};
